<template>
  <b-tab :title="__('Tax')">
    <Tax />
  </b-tab>
</template>

<script>
import Tax from './Settings';

export default {
  components: {
    Tax,
  },
};
</script>
